import { Box, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function TabsWidget({ value, onChange, items }) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    return (
        <Box
            sx={{
                color: Constants.Colors[currentMode].mutedForeground,
                backgroundColor: Constants.Colors[currentMode].secondary,
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: Constants.Styles.radius.base,
                display: "inline-flex",
                justifyContent: "start",
                alignItems: "center",
                padding: "3px",
            }}
        >
            {items.map((item) => {
                return (
                    <Stack key={item.key}
                        direction={"row"}
                        sx={{
                            color: Constants.Colors[currentMode].foreground,
                            backgroundColor: value === item.value ? Constants.Colors[currentMode].card : "transparent",
                            paddingBlock: `calc(${Constants.Styles.spacing} * 0.5)`,
                            paddingInline: `calc(${Constants.Styles.spacing} * 2)`,
                            border: `1px solid #0000`,
                            borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
                            cursor: "pointer",
                        }}
                        alignItems="center"
                        spacing={1}
                        onClick={() => onChange(item.value)}
                    >
                        {item.icon}
                        <Typography sx={{
                            whiteSpace: "nowrap",
                            fontWeight: Constants.Styles.fontWeight.medium,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                        }}>{item.label}</Typography>
                    </Stack>
                );
            })}
        </Box>
    );
}